import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import IconLocation from "@material-ui/icons/LocationOnOutlined";
import IconCompare from "@material-ui/icons/CompareArrows";
import AutoComplete from "./AutoCompleteCity";
import '../Flight/components/index.css'



export default function City(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [cityName, setCityName] = React.useState(null);


    React.useEffect(() => {
        setCityName(props.destination?.name)
    }, [props.destination])

    const handleDestinationChange = value => {
        return props?.onDestinationChange(value)
    }

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    return (
        <div className="row">
            <div style={{ width: '100%' }}>
                <div className="location-box" style={{padding:'5px'}}>
                    <div style={{ textAlign: "left", color: "var(--darker)" }}>
                        <div className="inline-block" style={{ width: '8%' }}>
                            <a
                                className="location-icon" style={{margin:0}}
                            >
                                <IconLocation />
                            </a>{" "}</div>
                        <div className="inline-block destination-name" style={{ width: '85%' }}>
                            <AutoComplete fullWidth text={cityName}
                                id="outlined-basic" placeholder="City"
                                onChange={handleDestinationChange}
                            /></div>
                    </div>
                </div>
            </div>
        </div>
    );
}
